import { render, staticRenderFns } from "./IconEye.vue?vue&type=template&id=48b56997"
import script from "./IconEye.vue?vue&type=script&lang=js"
export * from "./IconEye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports